import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import LabelWrapper from "components/Common/LabelWrapper";
import {
  COLOR_REFERRAL_REWARD_STATUS,
  getPlatFormImage,
  LIST_OPTION_BAR_LIST_OPEN_STATUS,
  LIST_REFERRAL_REWARD_STATUS_OPTION,
} from "helpers/constans";
import CountUp from "react-countup";
import { formatDateStringToKorea, formatDateStringToUTC, formatNumberWithCommas } from "helpers/format";
import TooltipCustom from "components/Common/TooltipCustom";
import CollapseFilter from "components/Common/CollapseFilter";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import moment from "moment";
import DatePickerCustom from "components/Common/DatePickerCustom";
import { getReferralRewards, updateReward } from "store/referral-rewards/thunk";
import CopyWrapper from "components/Common/CopyWrapper";
import CollapseContent from "components/Common/CollapseContent";
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from "common/toast";
import InputUpdateOnGrid from "components/Common/InputUpdateOnGrid";
import DropdownAsyncUsersReferral from "components/Common/DropdownAsyncUsersReferral";
import GroupInfoUser from "components/Common/GroupInfoUser";
import { Button, Dropdown, Menu } from "antd";
import { DownOutlined } from "@ant-design/icons";
import type { MenuProps } from 'antd';
import UpdateDropdownStatus from "components/Common/UpdateDropdownStatus";
import { removeTrailingZero } from "utils";

const TYPE_SELECT_DEFAULT: string = "created_at";

registerLocale("en", en);
registerLocale("ko", ko);

const ReferralRewards = () => {
  const { t, i18n } = useTranslation();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    receiver_id: withDefault(StringParam, ""),
    referral_user_id: withDefault(StringParam, ""),
    status: withDefault(StringParam, ""),
    start_date: withDefault(StringParam, ""),
    end_date: withDefault(StringParam, ""),
    sort_by: withDefault(StringParam, "created_at"),
    order_by: withDefault(StringParam, "DESC"),
  });

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.start_date
      ? moment(query?.start_date || "", "Y-MM-DD").toDate()
      : null,
    query?.end_date ? moment(query?.end_date || "", "Y-MM-DD").toDate() : null,
  ]);
  const [startDate, endDate] = dateSearch;

  const [referralUserSearch, setReferralUserSearch] = useState<any>({
    label: t("All Filter"),
    value: "all",
  });

  const [receiveUserSearch, setReceiveUserSearch] = useState<any>({
    label: t("All Filter"),
    value: "all",
  });

  const [statusSearch, setStatusSearch] = useState<any>(
    LIST_OPTION_BAR_LIST_OPEN_STATUS?.find(
      (item) => item?.value === query?.status
    )?.value || ""
  );

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.Reward;
  const RewardsProperties = createSelector(selectLayoutState, (state) => ({
    rewards: state.rewards,
    isRewardLoading: state.isRewardLoading,
    isRewardSuccess: state.isRewardSuccess,
    error: state.error,
  }));

  // Inside your component
  const { rewards, isRewardLoading } = useSelector(RewardsProperties);
  const [linkImage, setLinkImage] = useState<string>("");
  const [rewardStatusEdit, setRewardStatusEdit] = useState<any>(null);
  const [rewardNoteEdit, setRewardNoteEdit] = useState<any>(null);
  
  function loadTableData() {
    dispatch(getReferralRewards(query));
  }

  const searchData = () => {
    setQuery({
      ...query,
      receiver_id: (receiveUserSearch?.value !== 'all' ? receiveUserSearch?.value : ''),
      referral_user_id: (referralUserSearch?.value !== 'all' ? referralUserSearch?.value : ''),
      status: statusSearch,
      start_date: startDate
        ? formatDateStringToUTC(
          moment(new Date(startDate))
            .startOf("day")
            .format("Y-MM-DD HH:mm:ss")
        )
        : "",
      end_date: endDate
        ? formatDateStringToUTC(
          moment(new Date(endDate)).endOf("day").format("Y-MM-DD HH:mm:ss")
        )
        : "",
      sort_by: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        receiver_id: "",
        referral_user_id: "",
        status: "",
        start_date: "",
        end_date: "",
        sort_by: TYPE_SELECT_DEFAULT,
        time_request: +new Date(),
      },
      "push"
    );

    setReceiveUserSearch({
      label: t("All Filter"),
      value: "all",
    });
    setReferralUserSearch({
      label: t("All Filter"),
      value: "all",
    });
    setStatusSearch((_prev: any) => "");
    setDateSearch([null, null]);
  };

  const onCloseImageClick = () => {
    setLinkImage((_prev) => "");
  };

  const handleUpdateRewardOnGrid = async (id: any, key: string, value: any) => {
    try {
      const data = {
        [key]: value,
      };
      console.log(data, id)
      const response: any = await updateReward(id, data);
      if (response?.data) {
        setRewardStatusEdit(null);
        setRewardNoteEdit(null);
        dispatch(getReferralRewards(query));
        // if (resUpdatedArticle) {
        //   setFormatData((_prev: any) => _prev?.map((item: any) => (item?._id === postID ? resUpdatedArticle : item)));
        // }
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  }

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 70,
        Cell: ({ ...props }) => {
          return (
            <div style={{ minWidth: "60px" }}>
              {rewards?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "status",
        filterable: false,
        sortable: false,
        thWidth: 80,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const status = cell?.value;
          const msgError = item?.reason_rejected;

          return (
            <div className="position-relative d-flex align-items-center gap-1 justify-content-center" style={{ minWidth: i18n?.language === 'en' ? 125 : 100 }}>
              {
                <>
                { status === 'paid' ? (
                    <>
                    <div
                      className={`bg-${COLOR_REFERRAL_REWARD_STATUS[status]} cursor-pointer`}
                      style={{
                        color: "white",
                        borderRadius: "25px",
                        padding: "0px 14px",
                        height: "100%",
                        fontSize: "13px",
                      }}
                    >
                      {t(
                        LIST_REFERRAL_REWARD_STATUS_OPTION?.find(
                          (i) => i.value === status
                        )?.label || ""
                      )}
                    </div>
                    </>
                  ) : (
                    <UpdateDropdownStatus
                      item={item}
                      valueDefault={status}
                      handleUpdateStatus={handleUpdateRewardOnGrid}
                      optionsStatus={LIST_REFERRAL_REWARD_STATUS_OPTION}
                      colorStatus={COLOR_REFERRAL_REWARD_STATUS}
                    />
                  )
                }
                  
                  {status === "rejected" && msgError && (
                    <TooltipCustom
                      title={t(msgError)}
                      className="d-inline-block vertical-align-middle ms-1 thumbnail-mt"
                      style={{
                        transform: "translateY(2px)",
                        position: "absolute",
                        top: "calc(50% - 9px)",
                        right: 0,
                        paddingLeft: 4,
                        paddingRight: 3,
                        lineHeight: '18px'
                      }}
                    >
                      <i
                        className="ri-question-line align-bottom text-secondary"
                        style={{ fontSize: "16px" }}
                      ></i>
                    </TooltipCustom>
                  )}
                </>
              }
            </div>
          );
        },
      },
      {
        Header: t('Referral User'),
        accessor: "Referral User",
        thClass: 'align-middle text-start',
        filterable: false,
        sortable: false,
        thWidth: 600,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original?.referral_user;

          return (
            <GroupInfoUser item={item} />
          );
        },
      },
      {
        Header: t('Receive User'),
        accessor: "Receive User",
        thClass: 'align-middle text-start whitespace-nowrap',
        filterable: false,
        sortable: false,
        thWidth: 600,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original?.receiver_user;

          return (
            <GroupInfoUser item={item} />
          );
        },
      },
      {
        Header: t("Level"),
        accessor: "level",
        thWidth: 180,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          return cell?.value && (
            <div className="text-center" style={{ minWidth: 80 }}>
                {`${t('Level')} ${cell?.value}`} 
            </div>
          );
        },
      },
      {
        Header: t('Amount'),
        accessor: "amount",
        thClass: "text-end",
        thWidth: 150,
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="text-end" style={{ minWidth: '100px' }}>
              <div>{ formatNumberWithCommas(removeTrailingZero(cell?.value) || 0) }</div>
            </div>
          </>)
        },
      },
      {
        Header: `${t("Currency")}`,
        accessor: "currency",
        filterable: false,
        sortable: false,
        thWidth: 120,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          let imgPlatform = getPlatFormImage(cell?.value ?? '');

          return cell?.value && (
            <div style={{ textAlign: "center", minWidth: 100 }} >
              {imgPlatform && (
                <img
                  src={imgPlatform}
                  width={25}
                  height={25}
                  alt="currency"
                />
              )}
            </div>
          );
        },
      },
      {
        Header: t("Note"),
        accessor: "note",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 100,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const note = cell?.value;

          return (
            <div className="position-relative d-flex align-items-center gap-1 justify-content-left" style={{ minWidth: rewardNoteEdit ? 170 : 110 }}>
              {
                rewardNoteEdit === item?.id ? (
                  <>
                    <InputUpdateOnGrid valueDefault={note} rewardNoteEdit={rewardNoteEdit} item={item} handleUpdateRewardOnGrid={handleUpdateRewardOnGrid} setRewardNoteEdit={setRewardNoteEdit} />
                  </>
                ) : (
                  <>
                  {
                    note ? (
                      <CopyWrapper contentCopy={note}>
                        <CollapseContent
                          style={{ maxWidth: "100px" }}
                          dataOriginal={note}
                          isRank={false}
                          isInlineBlock={true}
                          isShowModal={true}
                          numberCharactor={60}
                          titleModal={t("Content")}
                        />
                      </CopyWrapper>
                    ) : '-'
                  }
                  </>
                )
              }
              <TooltipCustom
                title={t("Update Reward Note")}
                id={`tooltip-edit-reward-${item?.id}`}
                style={{ listStyleType: "none" }}
              >
                <div
                  className={`cursor-pointer ${rewardNoteEdit === item?.id ? "d-none" : "d-block"}`}
                  onClick={() => {
                    setRewardNoteEdit(item?.id);
                  }}
                >
                  <i
                    className="ri-pencil-fill text-primary"
                    style={{ fontSize: "16px", fontWeight: 500 }}
                  ></i>
                </div>
              </TooltipCustom>
            </div>
          );
        },
      },
      {
        Header: t("Created at"),
        accessor: "created_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Confirmed at"),
        accessor: "confirmed_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Paid at"),
        accessor: "paid_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, rewards?.pagination?.total, query?.page, rewardStatusEdit, rewardNoteEdit]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  useEffect(() => {
    loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  useEffect(() => {
    document.title = `${t("Invitation Reward Details")} - ${t('Home')} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Invitation Reward Details")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <div className="d-block d-xl-flex justify-content-between align-items-start">
                    <div
                      className="d-flex w-100 flex-wrap gap-3 gap-md-2 menu-card-statistics justify-content-start mb-3 mb-xl-2 position-relative"
                      style={{ maxWidth: "100%" }}
                    >
                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={rewards?.pagination?.total || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Pending")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      rewards?.summary?.pending ||
                                      0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Rejected")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      rewards?.summary?.rejected || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Confirm")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      rewards?.summary?.confirmed || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Paid")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      rewards?.summary?.paid || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                </CardHeader>

                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={6}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-xl-2"
                      >
                        <LabelWrapper label={t("Referral User")} isShow={true}>
                          <DropdownAsyncUsersReferral
                            name="referral-user"
                            onChangeSelect={(event: any) => {
                              setReferralUserSearch(event);
                            }}
                            isMulti={false}
                            placeholder={`${t("Select user")}...`}
                            isShowIconCheck={false}
                            isAllOption={true}
                            listCheckedUsers={referralUserSearch}
                            paramsTypeUsers={'referral'}
                            isClearable={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={6}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-xl-2"
                      >
                        <LabelWrapper label={t("Receive User")} isShow={true}>
                          <DropdownAsyncUsersReferral
                            name="receive-user"
                            onChangeSelect={(event: any) => {
                              setReceiveUserSearch(event);
                            }}
                            isMulti={false}
                            placeholder={`${t("Select user")}...`}
                            isShowIconCheck={false}
                            isAllOption={true}
                            listCheckedUsers={receiveUserSearch}
                            paramsTypeUsers={'receiver'}
                            isClearable={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={LIST_REFERRAL_REWARD_STATUS_OPTION || []}
                            placeholder={`${t("Select Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(e: any) =>
                              setStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_REFERRAL_REWARD_STATUS}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-4 mt-md-2 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!startDate || !!endDate}
                        >
                          <DatePickerCustom
                            startDate={startDate || null}
                            endDate={endDate || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={12}
                        xl={12}
                        xxl={12}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={rewards?.items?.length ? rewards?.items : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={rewards?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(rewards?.pagination?.total) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isRewardLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ReferralRewards;
